export const SET_FACTORS = 'SET_FACTORS'
export const SET_YEAR = 'SET_YEAR'
export const SET_QUESTIONTYPE = 'SET_QUESTIONTYPE'
export const SET_REGION = 'SET_REGION'
export const SET_DIFF = 'SET_DIFF'
export const SET_CART = 'SET_CART'
export const SET_CATALOG = 'SET_CATALOG'
export const SET_KPS = 'SET_KPS'
export const SET_BOOKORKPS = 'SET_BOOKORKPS'
export const SET_DEFAULTBOOK = 'SET_DEFAULTBOOK'
export const SET_SINGLEORMULTI = 'SET_SINGLEORMULTI'
export const SET_BOOK = 'SET_BOOK'
export const SET_DIFFNAME = 'SET_DIFFNAME'
export const SET_QUESTIONTYPENAME = 'SET_QUESTIONTYPENAME'
export const SET_PROVINCENAME = 'SET_PROVINCENAME'

export const SET_TEXTBOOK_VERSION = 'SET_TEXTBOOK_VERSION'
export const SET_GRADE = 'SET_GRADE'
export const SET_PAPER_TYPE = 'SET_PAPER_TYPE'
